import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const SectionDescription = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
`;

export const Score = styled('div')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  p {
    margin: 0;
  }
  span {
    ${({ theme }) => theme.typography.mega}
    color: ${({ theme }) => theme.color.white};
  }
`;

export const SnowflakeWrapper = styled('div')`
  display: none;
  justify-content: center;
  align-items: center;
  ${media.smUp`
    display: flex;
  `}

  > div {
    max-width: 200px;
  }
`;

export const MobileTitleWrapper = styled('div')`
  ${media.smUp`
    display: none;
  `}
`;

export const SnowflakeFallback = styled('div')`
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 100%;
`;
